import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import styles from '../common/styles';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';
import { toTitleCase } from '../common/Util';
import moment from 'moment';

type Props = {
  width: number;
  hseUnit: PersonDTO;
  signatureDate?: string;
};

export const HSEUnit = ({ width, hseUnit, signatureDate }: Props) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.thinRoundBorder]}>
      <View style={styles.accordianSubTitle}>
        <Text>{t('traceability.form.details.page.container.hse.unit')}</Text>
      </View>
      <View></View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.name')}</Text>
          </View>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{t('traceability.form.details.page.container.person.date')}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{toTitleCase(hseUnit.firstName + ' ' + hseUnit.lastName)}</Text>
          </View>
          <View style={[{ width: width }, styles.bold]}>
            <Text>{moment(signatureDate).utc().format('DD-MM-YYYY')}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};
